// src/stores/usuarioStore.ts

import { defineStore } from "pinia";
import axios from "axios";
import KeycloakService from "@/core/services/KeycloakService";
import type { PerfilDados } from "@/core/types/usuario";

export const useUsuarioStore = defineStore("usuario", {
  state: () => ({
    id: null as number | null,
    nome: null as string | null,
    usuario: null as string | null,
    email: null as string | null,
    situacao: null as string | null,
    cadastradoEm: null as string | null,
    perfilDados: null as PerfilDados | null,
    perfilSelecionado: null as string | null,
    carregando: false,
    erro: null as string | null,
    dadosCarregados: false,
  }),

  actions: {
    async carregarDadosUsuario() {
      if (this.dadosCarregados) return;

      try {
        this.carregando = true;

        const token = process.env.VUE_APP_JWT_TOKEN;
        const keycloakToken = KeycloakService.getInstance().token;
        const id = KeycloakService.getInstance().subject;
        const apiUrl = `${process.env.VUE_APP_ADMIN_API}/usuario/${id}`;

        const result = await axios.get(apiUrl, {
          headers: {
            "x-autenticacao": `Bearer ${keycloakToken}`,
            Authorization: `Bearer ${token}`,
            "X-Apikey": `Bearer ${token}`,
          },
        });

        const dados = result.data?.dados;

        if (dados) {
          this.id = dados.id;
          this.nome = dados.nome;
          this.usuario = dados.usuario;
          this.email = dados.email;
          this.situacao = dados.situacao;
          this.cadastradoEm = dados.cadastradoEm;

          if (dados.atributos) {
            if (
              dados.atributos.perfil_dados &&
              dados.atributos.perfil_dados.length > 0
            ) {
              try {
                this.perfilDados = JSON.parse(dados.atributos.perfil_dados[0]);
              } catch (e) {
                console.error("Erro ao fazer parse do perfil_dados:", e);
                this.perfilDados = null;
              }
            }

            this.perfilSelecionado = dados.atributos.perfil_selecionado || null;
          }

          this.dadosCarregados = true;
        }
      } catch (error: any) {
        this.erro = error.message;
        console.error("Erro ao carregar dados do usuário:", error);
      } finally {
        this.carregando = false;
      }
    },

    limparDados() {
      this.id = null;
      this.nome = null;
      this.usuario = null;
      this.email = null;
      this.situacao = null;
      this.cadastradoEm = null;
      this.perfilDados = null;
      this.perfilSelecionado = null;
      this.dadosCarregados = false;
      this.erro = null;
    },
  },

  getters: {
    nomeUsuario: (state) => state.nome,
    emailUsuario: (state) => state.email,
    dadosCompletos: (state) => ({
      id: state.id,
      nome: state.nome,
      usuario: state.usuario,
      email: state.email,
      situacao: state.situacao,
      cadastradoEm: state.cadastradoEm,
      perfilDados: state.perfilDados,
      perfilSelecionado: state.perfilSelecionado,
    }),
    estaCarregado: (state) => state.dadosCarregados && !state.carregando,
  },

  persist: true,
});
